import * as types from "./types";
import * as mutation_types from "./mutation_types";
import {
    Get,
    SetLocalizeList,
    SetSettings,
    SetCurrency,
    SetLocalize,
    SetBasketCurrency,
    convertPrice,
    getQuotaServices,
    getCurrencyRates
} from "./api/methods";


export default {
    [types.A_SET_LOCALIZE_LIST] ( context, payload ) {
        const sendData = {
            code: payload,
            API_ORIGIN: context.state.API_ORIGIN,
            PATH: context.state.PATH
        };
        return new Promise((resolve, reject) => {
            SetLocalizeList(sendData)
                .then(data => {
                    let localizeList = {};
                    let res = data
                        .split("\n")
                        .slice(2)
                        .map(x => {
                            x = x.split("|");
                            if (x[1])
                                x[1] = x[1].trim();
                            return x
                        });

                    res.forEach(x => {
                        localizeList[x[0]] = x[1]
                    });
                    context.commit(mutation_types.M_SET_LOCALIZE_LIST, localizeList);
                    resolve()
                })
                .catch(() => {
                    context.commit(mutation_types.M_SET_LOCALIZE_ERROR);
                    reject()
                })
        })
    },
    [types.A_SET_SETTINGS] ( context ) {
        return new Promise((resolve, reject) => {
            const date = new Date().getTime();
            const params = {
                date,
                API_URL: context.state.API_URL
            }
            SetSettings(params).then(res => {
                context.commit(mutation_types.M_SET_SETTINGS, res);
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    [types.A_SET_CURRENCY] ( context ) {
        return new Promise((resolve) => {
            const date = new Date().getTime();
            const params = {
                date,
                API_URL: context.state.API_URL
            }
            SetCurrency(params).then(res => {
                let nationalCurrency = res.data.find(x => x.IsNational);
                if (!JSON.parse(localStorage.getItem("Rate"))) {
                    localStorage.setItem("Rate", JSON.stringify(nationalCurrency))
                }
                context.commit(mutation_types.M_SET_CURRENCY, res);
                resolve(res.data)
            })
        })
    },
    [types.A_SET_ALL_CURRENCY] ( context ) {
        return new Promise((resolve) => {
            const date = new Date().getTime();
            Get(context.state.API_URL + 'AllCurencies/getAllCurrencies?_=' + date).then(res => {
                context.commit(mutation_types.M_SET_ALL_CURRENCY, res);
                resolve(res.data)
            })
        })
    },
    [types.A_LOCALIZE] ( context ) {
        return new Promise((resolve) => {
            const date = new Date().getTime();
            const params = {
                date,
                API_ORIGIN: context.state.API_ORIGIN,
                PATH:context.state.PATH
            };
            SetLocalize(params).then(res => {
                res.data = res.data.split("|").filter(x => !x.includes("custom")).join("|");
                context.commit(mutation_types.M_LOCALIZE, res);
                resolve(res.data)
            })
        })
    },
    [types.A_SET_BUSKET_CURRENCY] ( context) {
        return new Promise(() => {
            const date = new Date().getTime();
            const params = {
                date,
                API_URL: context.state.API_URL
            };
            SetBasketCurrency(params).then(res => {
                context.state.busketCurrencyReady = res.data;
            })
        })
    },
    [types.A_SET_ALERT] ( context, payload ) {
        context.commit(mutation_types.M_SET_ALERT, payload)
    },
    [types.A_SHOW_POPOVER] ( context, payload ) {
        context.commit(mutation_types.M_SHOW_POPOVER, payload)
    },
    [types.A_HIDE_POPOVER] ( context ) {
        context.commit(mutation_types.M_HIDE_POPOVER)
    },
    [types.A_SET_SERVER_OFF] ( context ) {
        context.commit(mutation_types.M_SET_SERVER_OFF)
    },
    [types.A_SET_PATH] ( context, payload) {
        context.commit(mutation_types.M_SET_PATH, payload)
    },
    [types.A_SET_API_URL] ( context, payload) {
        context.commit(mutation_types.M_SET_API_URL, payload)
    },
    [types.A_SET_API_ORIGIN] ( context, payload) {
        context.commit(mutation_types.M_SET_API_ORIGIN, payload)
    },
    [types.A_CONVERT_PRICE] ( context, payload) {
        return new Promise((resolve) => {
            const date = new Date().getTime();
            const params = {
                date,
                API_URL: context.state.API_URL,
                oldRateKey: payload.keys[0].Key,
                newRateKey: payload.keys[1].Key,
                minPrice: payload.price[0],
                maxPrice: payload.price[1],
            };
            convertPrice(params).then(res => {
                resolve(res)
            })
        })
    },
    [types.A_GET_QUOTA_SERVICES] ( context) {
        const date = new Date().getTime();
        const url = context.state.API_URL + "QuotedServices?_=" + date;

        getQuotaServices(url).then(res => {
            context.commit(mutation_types.M_SET_QUOTA_SERVICES, res.data)
        })
    },
    [types.A_SET_CONFIG_URLS] ( context) {
        context.commit(mutation_types.M_SET_CONFIG_URLS)
    },
    [types.A_SET_CURRENCY_RATES] (context) {
        let url = context.state.API_URL + "CurrencyRates";
        if(window.settings.NationalCurrencyCode)
        {
            let nationalCurrencyCode=window.settings.NationalCurrencyCode;
             url +="?nationalCurrencyCode=" + nationalCurrencyCode;
            getCurrencyRates(url)
            .then(res => {
                context.commit(mutation_types.M_SET_CURRENCY_RATES, res.data)
            })
        }
        else{
            getCurrencyRates(url)
            .then(res => {
                context.commit(mutation_types.M_SET_CURRENCY_RATES, res.data)
            })
        } 
    },
    [types.A_CHANGE_THEME] (context, payload) {
        context.commit(mutation_types.M_CHANGE_THEME, payload)
    },
};
